export const CREATE_SESSION = "CREATE_SESSION";
export const SET_SESSION_DATA = "SET_SESSION_DATA";
export const SET_IS_LOADING = "SET_IS_LOADING";
